// i18n-ignore — Excel template catalog, translated separately from next-intl.
// Keys are decoded from the template shared strings; keep placeholders in dynamic templates.
export const XLSX_ES: Record<string, string> = {
  'AI Film Budget': 'Presupuesto de cine con IA',
  'Yellow cells are inputs. Everything else is a formula. Estimates, not quotes.':
    'Las celdas amarillas son datos de entrada. Todo lo demás es una fórmula. Estimaciones, no cotizaciones.',
  INPUTS: 'DATOS DE ENTRADA',
  Runtime: 'Duración',
  min: 'min',
  'finished length of the whole piece': 'duración final de la pieza completa',
  'Share that is AI': 'Porcentaje de IA',
  '%': '%',
  'rest is live action / archive, not priced here':
    'el resto es acción real o material de archivo; no se presupuesta aquí',
  'Length of each generation': 'Duración de cada generación',
  s: 's',
  'every generated second is billed (4–30 s)': 'se cobra cada segundo generado (4–30 s)',
  'Seconds used from a shot': 'Segundos usados de cada plano',
  'one shot or several angles cut from the same generation': 'un plano o varios ángulos de la misma generación',
  'Generations to get one shot': 'Generaciones para lograr un plano',
  '×': '×',
  'conservative; House of David ≈ 20': 'conservador; House of David ≈ 20',
  'Drafts share': 'Porcentaje de borradores',
  'share of generations run as cheap 480p drafts':
    'porcentaje de generaciones hechas como borradores económicos en 480p',
  'Look-dev stills per shot': 'Fotogramas de look dev por plano',
  'Deliver in HDR (1 = yes)': 'Entregar en HDR (1 = sí)',
  'Topaz Hyperion 2.5 on Martini': 'Topaz Hyperion 2.5 en Martini',
  'HDR pass rate ($/s, Topaz Hyperion on Martini)': 'Tarifa del pase HDR ($/s, Topaz Hyperion en Martini)',
  '$/s': '$/s',
  'follows the resolution in B22': 'se ajusta a la resolución de B22',
  'Generations per creator per day': 'Generaciones por creador por día',
  '/day': '/día',
  'PJ Accetturo: 300–400 in two days': 'PJ Accetturo: 300–400 en dos días',
  'Creator day rate': 'Tarifa diaria del creador',
  '$/day': '$/día',
  'no published rate for AI creators': 'no hay una tarifa publicada para creadores que trabajan con IA',
  'Team size': 'Tamaño del equipo',
  'creators working at once': 'creadores trabajando a la vez',
  'Share needing a cleanup pass': 'Porcentaje que necesita limpieza',
  'forgiving (stylized) 0% → exacting (brand, likeness) 100%':
    'flexible (estilizado) 0% → exigente (marca, personas reales) 100%',
  'Compositor hours each': 'Horas de compositor por plano',
  h: 'h',
  'Compositor day rate': 'Tarifa diaria del compositor',
  'RATES (from sheet Rates)': 'TARIFAS (de la hoja Tarifas)',
  'Final resolution (720, 1080 or 4K)': 'Resolución final (720, 1080 o 4K)',
  '1080': '1080',
  'type 720, 1080 or 4K': 'escribe 720, 1080 o 4K',
  'Draft rate (480p)': 'Tarifa de borrador (480p)',
  'Final rate at chosen resolution': 'Tarifa final a la resolución elegida',
  'Still rate': 'Tarifa por fotograma',
  '$/image': '$/imagen',
  'Olive price': 'Precio de la aceituna',
  $: '$',
  MODEL: 'MODELO',
  'AI seconds on screen': 'Segundos de IA en pantalla',
  'Shots needed': 'Planos necesarios',
  'Generations run': 'Generaciones realizadas',
  'Drafts per shot': 'Borradores por plano',
  'Finals per shot': 'Finales por plano',
  'Cost per draft': 'Costo por borrador',
  'Cost per final': 'Costo por final',
  'Generation per shot': 'Generación por plano',
  'Generation: video': 'Generación: video',
  'Generation: stills': 'Generación: fotogramas',
  'Generation: HDR pass': 'Generación: pase HDR',
  GENERATION: 'GENERACIÓN',
  'Creator-days': 'Jornadas de creador',
  days: 'días',
  'Calendar months': 'Meses de calendario',
  months: 'meses',
  PERSONNEL: 'PERSONAL',
  'Shots needing cleanup': 'Planos que necesitan limpieza',
  'Cleanup cost each': 'Costo de limpieza por plano',
  CLEANUP: 'LIMPIEZA',
  'TOP SHEET': 'RESUMEN',
  Generation: 'Generación',
  Personnel: 'Personal',
  Cleanup: 'Limpieza',
  TOTAL: 'TOTAL',
  'per AI minute': 'por minuto de IA',
  '$/min': '$/min',
  'Olives (generation ÷ olive price)': 'Aceitunas (generación ÷ precio de la aceituna)',
  olives: 'aceitunas',
  'Generated : on screen': 'Generado : en pantalla',
  '× : 1': '× : 1',
  'Share: generation': 'Porcentaje: generación',
  'Share: personnel': 'Porcentaje: personal',
  'Share: cleanup': 'Porcentaje: limpieza',
  'SENSITIVITY RANGE (seconds used and creator pace ÷ and × 1.3)':
    'RANGO DE SENSIBILIDAD (segundos usados y ritmo del creador ÷ y × 1.3)',
  Low: 'Bajo',
  High: 'Alto',
  'Martini public per-model rates': 'Tarifas públicas por modelo de Martini',
  'Source: https://www.martini.film/pricing#per-model-pricing':
    'Fuente: https://www.martini.film/pricing#per-model-pricing',
  'As of: Oct 10, 2026': 'Vigentes al: 10 oct 2026',
  Model: 'Modelo',
  Resolution: 'Resolución',
  'USD / s': 'USD / s',
  Note: 'Nota',
  'Seedance 2.5': 'Seedance 2.5',
  '480p (drafts)': '480p (borradores)',
  'draft rate': 'tarifa de borrador',
  '720p': '720p',
  '1080p': '1080p',
  'Seedance 2.0': 'Seedance 2.0',
  '4K': '4K',
  '2.5 has no 4K': '2.5 no tiene 4K',
  'Seedream 5 Pro': 'Seedream 5 Pro',
  '1K image': 'Imagen 1K',
  'USD per image': 'USD por imagen',
  Olive: 'Aceituna',
  'USD per olive': 'USD por aceituna',
  'Model version: v1   Rates as of: Oct 10, 2026': 'Versión del modelo: v1   Tarifas vigentes al: 10 oct 2026',
  'Reopen online: https://www.martini.film/budget  (engineering: write the exact URL with parameters here at export time)':
    'Volver a abrir en línea',
  'Estimates, not quotes. Generation uses Martini public per-model rates. Creator and compositor day rates are placeholders for your own numbers.':
    'Estimaciones, no cotizaciones. La generación usa las tarifas públicas por modelo de Martini. Las tarifas diarias de creadores y compositores son valores de referencia para que pongas tus propias cifras.',
  'The sensitivity range recomputes with seconds-used and creator pace ÷ and × 1.3. It is a check, not a confidence interval.':
    'El rango de sensibilidad se recalcula dividiendo y multiplicando por 1.3 los segundos usados y el ritmo del creador. Es una comprobación, no un intervalo de confianza.',
  "Picture only. Not included (separate budget): live action, voice actors, sound design, sound effects, foley, music, editing, grade, re-render reserve, platform fees. Rates are for Seedance (best in class when this was made); type another model's rates into the Rates sheet to reprice.":
    'Solo imagen. No incluye (presupuesto aparte): acción real, actores de voz, diseño sonoro, efectos de sonido, foley, música, edición, etalonaje, reserva para volver a renderizar ni cuotas de plataforma. Las tarifas son de Seedance (el mejor de su clase cuando se hizo esto); escribe las tarifas de otro modelo en la hoja Tarifas para volver a calcular.',
  'Defaults are conservative; benchmarks: Curious Refuge, House of David (~20×), Kavan the Kid (~90×), PJ Accetturo.':
    'Los valores predeterminados son conservadores; referencias: Curious Refuge, House of David (~20×), Kavan the Kid (~90×), PJ Accetturo.',
  'Pre-production creator-days': 'Jornadas de creador en preproducción',
  'Topaz Hyperion 2.5': 'Topaz Hyperion 2.5',
  'Look dev, style frames, characters, sets, tests. Billed at the creator day rate.':
    'Look dev, style frames, personajes, escenarios, pruebas. Se cobra a la tarifa diaria del creador.',
  'HDR pass, up to 1080p': 'Pase HDR, hasta 1080p',
  'HDR pass, 4K': 'Pase HDR, 4K',
  'USD per finished second': 'USD por segundo terminado',
  Budget: 'Presupuesto',
  Rates: 'Tarifas',
  About: 'Acerca de',
  'As of: {date}': 'Vigentes al: {date}',
  'Model version: v{version} · Rates as of: {date}': 'Versión del modelo: v{version} · Tarifas vigentes al: {date}',
  'Reopen online: {url}': 'Volver a abrir en línea: {url}',
}
